import { FunctionComponent, memo } from 'react';

import { getDomainEnvironment } from '@/core/platform/domains/getDomainEnvironment';
import { Image } from '@/domains/core/Image/Image';
import { getPlatform, isB2B } from '@/domains/core/settings/utils';

import { flagLinks } from './constants.default';

export const getAdjustedHref = (href: string): string => {
  const env = (getDomainEnvironment() || '').replace('.', ''); // '' or 'int' or 'stg'
  const b2b = isB2B(); // true if 'pro' in the URL

  if (env) {
    return b2b
      ? href.replace(
          /https:\/\/(www\.|pro\.)?manomano/,
          `https://pro.${env}.manomano`,
        )
      : href.replace(/https:\/\/(www\.)?manomano/, `https://${env}.manomano`);
  }

  if (b2b && !href.includes('pro.')) {
    return href.replace(/https:\/\/(www\.)?manomano/, 'https://pro.manomano');
  }

  return href;
};

export const Flags: FunctionComponent = memo(() => (
  <div className="flex gap-m">
    {flagLinks
      .filter((flag) => flag.value !== getPlatform())
      .map(({ value, href, dataQa, name }) => (
        <a
          key={value}
          title={value}
          href={getAdjustedHref(href)}
          rel="noopener noreferrer"
          target="_blank"
          aria-label={name}
          data-testid={dataQa}
        >
          <Image
            width={32}
            height={32}
            alt={name}
            src={`/assets/img/themes/default/svg/flags/${value}.svg`}
          />
        </a>
      ))}
  </div>
));

Flags.displayName = 'Flags';
